import { render, staticRenderFns } from "./announcement-detail.vue?vue&type=template&id=196333f6"
import script from "./announcement-detail.vue?vue&type=script&lang=js"
export * from "./announcement-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports